import { render, staticRenderFns } from "./EditFundPage.vue?vue&type=template&id=57c4db94&"
import script from "./EditFundPage.vue?vue&type=script&lang=ts&"
export * from "./EditFundPage.vue?vue&type=script&lang=ts&"
import style0 from "./EditFundPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports